/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useRef,
  useEffect,
} from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Select from '../../atoms/select/select';
import Badge from '../../atoms/badge/badge';
import FormValidation from '../../atoms/formEnums/formValidation';
import Label from '../../atoms/label/label';
import { IconType } from '../../atoms/icon/icon';
import AsyncSelect from '../../atoms/asynSelect/asyncSelect';
import swal from 'sweetalert';


/**
 * Form select is a multiple select input designed to work inside a form component.
 * It contains a label, HelpButton, Select and badges.
 * The multiple select is saved on key array and it’s sent to the parent component.
 */
const FormConfirmSelect = forwardRef((props, ref) => {
  const {
    id, options, label, validation, errorText, helpText, multiple, value, onChange, asyncSelect, placeholder, url,validateUrl, session, filter,fieldValue,fieldName,emptyValue,pageId,disabled,parentField,refreshData,allValue,writable,fieldDisabled,fieldDisabledReason,confirmTitle,confirmText
  } = props;
  const childRef = useRef();
  const [valueState, setValueState] = useState(value ?? "");
  const prevValueRef = useRef(value ?? ""); // store last confirmed value
  useEffect(() => {
      setValueState(value ?? "");
      prevValueRef.current = value ?? ""; // keep in sync with parent
    // console.log("value",value);
    // setValueState(value);
    // if (value !== valueState) {
    //   if(multiple){
    //     const newValue = Array.isArray(value) ? value : value != "" ? value.split(',') : [];
    //     setValueState(newValue);
    //   } else {
    //     setValueState(value);
    //   }

    //   childRef.current.updateValue(value);
    // }

  }, [value]);
  
  useEffect(() => {
    //  setValueState(value);
    // if(emptyValue && currentOptions){
    //     if(currentOptions.find(element => element.value == '(Empty)')==undefined){
    //       currentOptions.unshift({"value":'(Empty)',"name":'(no selection)'});
    //     }
    // }
  }, []);

 
  const onChangeValue = (event) => {
    const newValue = event.target.value;

    swal({
      title: confirmTitle ?? "Are you sure?",
      text: confirmText ?? "You are about to change the value",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((ok) => {
      if (ok) {
        //  Confirmed → accept new value
        setValueState(newValue);
        prevValueRef.current = newValue;
        onChange({ target: { value: newValue } });
      } else {
        //  Cancel → revert to previous confirmed value
        setValueState(prevValueRef.current);

        // force notify parent (in case it relies on re-render)
        onChange({ target: { value: prevValueRef.current } });
        childRef.current.updateValue(prevValueRef.current);
      }
    });
  };

  return (
     <div className={`form-group row text-${validation}`}>
      {label && <Label helpText={helpText}>{label}</Label>}
      <div className={`${multiple ? "col-sm-8" : "col"}`}>
        <Select
          ref={childRef}
          id={id}
          options={options}
          validation={validation}
          onChange={onChangeValue}
          emptyValue={emptyValue}
          value={valueState}     
          disabled={disabled}
          writable={writable}
        />
        {(validation === FormValidation.ERROR ||
          validation === FormValidation.WARNING) && (
          <small className="form-text">{errorText}</small>
        )}
      </div>
    </div>
  );
});

FormConfirmSelect.propTypes = {
  /**
   * Id of select input
   */
  id: PropTypes.string,
  /**
   * Select options defined by name and value
   */
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })), PropTypes.string]).isRequired,
  /**
   * Name of select attribute
   */
  label: PropTypes.string,
  /**
   * Defined text errors
   */
  errorText: PropTypes.string,
  /**
   * Help text
   */
  helpText: PropTypes.string,
  /**
   * FormSelect form status, it is a FormValidation enum
   */
  validation: PropTypes.oneOf(Object.values(FormValidation)),
  /**
 * Initial select value
 */
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    PropTypes.string,
    PropTypes.number,
  ]),
  /**
   * To use the form select with multiple options or single options
   */
  multiple: PropTypes.bool,
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
};

FormConfirmSelect.defaultProps = {
  id: '',
  label: '',
  validation: FormValidation.PENDING,
  errorText: '',
  helpText: '',
  value: '',
  multiple: false,
  onChange: () => {},
};

export default FormConfirmSelect;
